import type { ViewerTestPayload } from '../../shared/viewerTestPayload';
import { requestJson } from './requestJson';

export async function getViewerTest(testId: string): Promise<ViewerTestPayload> {
  return await requestJson(`/api/tests/${encodeURIComponent(testId)}`);
}
